import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function SandboxEnvironment() {
  const [envs, setEnvs]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [form, setForm]   = useState({ name: '', base_url: '' });

  const load = async () => {
    setLoading(true);
    try { const r = await api.get('/tenant/sandbox'); setEnvs(r.data); }
    catch (err) {
      if (err.response?.status === 403) toast.error('Sandbox requires Professional plan or higher');
      else toast.error(err.response?.data?.error || 'Failed');
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name.trim()) { toast.error('Name required'); return; }
    try { await api.post('/tenant/sandbox', form); toast.success('Sandbox created'); setCreating(false); setForm({ name: '', base_url: '' }); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Failed'); }
  };

  const reset = async (id) => {
    if (!window.confirm('Reset this sandbox? All test data will be cleared.')) return;
    try { await api.post(`/tenant/sandbox/${id}/reset`); toast.success('Sandbox reset'); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Failed'); }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this sandbox?')) return;
    try { await api.delete(`/tenant/sandbox/${id}`); toast.success('Sandbox deleted'); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Failed'); }
  };

  const S = { card: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: 20, marginBottom: 12 } };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600 }}>Sandbox Environments</h2>
        <button onClick={() => setCreating(!creating)} className="btn btn-primary">＋ New Sandbox</button>
      </div>

      {creating && (
        <div style={S.card}>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Create Sandbox</h3>
          <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Sandbox name *" className="input" style={{ width: '100%', marginBottom: 10 }} />
          <input value={form.base_url} onChange={e => setForm(f => ({ ...f, base_url: e.target.value }))} placeholder="Base URL (optional) — https://sandbox.api.example.com" className="input" style={{ width: '100%', marginBottom: 12 }} />
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={create} className="btn btn-primary">Create</button>
            <button onClick={() => setCreating(false)} className="btn btn-ghost">Cancel</button>
          </div>
        </div>
      )}

      {loading ? <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-3)' }}>Loading…</div> : (
        envs.length === 0
          ? <div style={{ ...S.card, textAlign: 'center', color: 'var(--text-3)', padding: 40 }}>No sandbox environments. Create one to safely test API integrations.</div>
          : envs.map(e => (
            <div key={e.id} style={S.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                    <strong style={{ fontSize: 14 }}>{e.name}</strong>
                    <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4, background: e.status === 'active' ? '#a6e3a122' : 'var(--bg)', color: e.status === 'active' ? '#a6e3a1' : 'var(--text-3)', letterSpacing: 1 }}>{e.status?.toUpperCase()}</span>
                  </div>
                  {e.base_url && <code style={{ fontSize: 12, color: 'var(--text-3)' }}>{e.base_url}</code>}
                  {e.reset_at && <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 4 }}>Last reset: {new Date(e.reset_at).toLocaleString()}</div>}
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => reset(e.id)} className="btn btn-ghost" style={{ fontSize: 11 }}>Reset</button>
                  <button onClick={() => remove(e.id)} className="btn btn-ghost" style={{ fontSize: 11, color: '#f38ba8' }}>Delete</button>
                </div>
              </div>
            </div>
          ))
      )}
    </div>
  );
}
